module.exports = __webpack_public_path__ + "48a5233992b25b7a1631cd7babbedff1.svg";


//////////////////
// WEBPACK FOOTER
// ./spa/images/new-design/icons/paypal.svg
// module id = 1276
// module chunks = 73